import _ from 'lodash'
import moment from 'moment/moment'
import React from 'react'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import DatePicker from 'react-datepicker'
import { Field, reduxForm } from 'redux-form'

let DefectAdd = props => {
  const {
    handleSubmit, onSubmit, submitting, errors,
    setChecklistDailyCurrentField, projectId, authorUserId, defectAreaId, expectedDeliveryDate,
    assignee, searchUser, setUserSelected, uploadImage, imageData, images
  } = props
  const image = imageData && imageData.length > 0 ? (
    <div className="row">
      <div className="row col-md-12">
        <p className="form-control-label">รูปภาพบริเวณที่เกิดข้อบกพร่อง</p>
      </div>
      <div className="row col-md-12">
        {_.map(imageData || [], (data, index) => (
          <div key={index} className="card mx-sm-1">
            <img src={data} alt="" style={{ height: '64px', width: '64px' }}/>
          </div>
        ))}
      </div>
      <br/>
    </div>
  ) : undefined
  return (
    <div>
      <div className="pd-x-20 pd-sm-x-30 pd-t-20 pd-sm-t-30">
        <h4 className="tx-gray-800 mg-b-5">Checklist Daily Result</h4>
      </div>
      <div className="br-pagebody">
        <div className="br-section-wrapper">
          <form onSubmit={handleSubmit((values) => {
            onSubmit(_.merge({
              projectId,
              defectAreaId,
              authorUserId,
              expectedDeliveryDate
            }, values), assignee.selected[0], images)
          })}>
            <div className="row align-items-center justify-content-center checklist-daily-defect-add">
              <div className="card col-md-12">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label htmlFor="detail" className="col-md-3 col-form-label form-control-label">รายละเอียด :</label>
                        <div className="col-md-9">
                          <Field name="detail" component="textarea" type="text" placeholder="รายละเอียด" rows="7"
                                 className="form-control"/>
                          {errors.detail ? <span className="text-danger">{errors.detail}</span> : undefined}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      {/*<div className="form-group row">*/}
                        {/*<label htmlFor="expectedDeliveryDate" className="col-md-4 col-form-label form-control-label">*/}
                          {/*วันที่คาดว่าจะเสร็จ :</label>*/}
                        {/*<div className="col-md-8 datepicker-container">*/}
                          {/*<DatePicker className="form-control" placeholderText="คลิกเพื่อเลือกวันที่"*/}
                                      {/*dateFormat="DD/MM/YYYY"*/}
                                      {/*selected={expectedDeliveryDate}*/}
                                      {/*onChange={(value) => setChecklistDailyCurrentField('expectedDeliveryDate', value)}/>*/}
                          {/*{errors.expectedDeliveryDate ? <span*/}
                            {/*className="text-danger">{errors.expectedDeliveryDate}</span> : undefined}*/}
                        {/*</div>*/}
                      {/*</div>*/}
                      <div className="form-group row">
                        <label htmlFor="assignee" className="col-md-4 col-form-label form-control-label">มอบหมายให้ :</label>
                        <div className="col-md-8">
                          <AsyncTypeahead
                            multiple={false} minLength={1} labelKey="name" placeholder="ค้นหาผู้ที่เกี่ยวข้อง..."
                            isLoading={assignee.isLoading || false} options={assignee.list ? assignee.list.rows : []}
                            onSearch={(query) => searchUser(query, 'assignee')}
                            onChange={(selected) => setUserSelected(selected, 'assignee')}/>
                          {errors.assignee ? <span className="text-danger">{errors.assignee}</span> : undefined}
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-md-4 col-form-label form-control-label"/>
                        <div className="col-md-8">
                          <input type="file" className="form-control" accept="image/*" multiple onChange={uploadImage}/>
                        </div>
                      </div>
                    </div>
                  </div>
                  {image}
                  <br/>
                  <div className="row float-right">
                    <button type="submit" className="btn btn-dark" disabled={submitting}>ตกลง</button>
                    <span>&nbsp;&nbsp;&nbsp;</span>
                    <button type="button" className="btn btn-light" disabled={submitting}
                            onClick={() => setChecklistDailyCurrentField('defectAreaId', undefined)}>
                      ปิด
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div> 
      </div>  
    </div>
  )
}

DefectAdd = reduxForm({
  form: 'checklist-daily-defect-add',
  enableReinitialize: true,
})(DefectAdd)

class ChecklistDaily extends React.Component {
  render () {
    const {
      list, handleSubmit, onSubmit, submitting, goBack, results,
      onDefectAddSubmit, defectAddErrors, setChecklistDailyCurrentField, projectId, authorUserId,
      defectAreaId, assignee, searchUser, setUserSelected, uploadImage, imageData, images
    } = this.props
    if (!list) return (<div/>)
    let currentMainAreaName
    const defectAddProps = {
      onSubmit: onDefectAddSubmit,
      errors: defectAddErrors,
      projectId,
      authorUserId,
      defectAreaId,
      setChecklistDailyCurrentField,
      expectedDeliveryDate: moment().add(7, 'day'),
      assignee,
      searchUser,
      setUserSelected,
      uploadImage,
      imageData,
      images
    }
    const defectAdd = defectAreaId ? <DefectAdd {...defectAddProps}/> : undefined
    return (
      <div>
        <div className="pd-x-20 pd-sm-x-30 pd-t-20 pd-sm-t-30">
          <h4 className="tx-gray-800 mg-b-5">ตรวจสอบรายการประจำวัน</h4>
        </div>
        <div className="br-pagebody">
          <div className="br-section-wrapper">
            <form onSubmit={handleSubmit((values) => {onSubmit(values)})}>
            <div className="row align-items-center justify-content-center">
              <div className="col-md-12">
                <div className="">
                  {list ?
                    <table className="table table-bordered table-colored table-dark">
                      <thead>
                      <tr>
                        <th scope="col">พื้นที่หลัก</th>
                        <th scope="col">บริเวณที่เกิดข้อบกพร่อง</th>
                        <th scope="col">ผลการตรวจสอบ</th>
                        <th scope="col"/>
                      </tr>
                      </thead>
                      <tbody>
                      {list.length > 0 ? list.map(row => {
                          let mainAreaName = ''
                          if (currentMainAreaName !== row.mainAreaName) {
                            currentMainAreaName = row.mainAreaName
                            mainAreaName = currentMainAreaName
                          }
                          return (
                            <tr key={row.id}>
                              <td>{mainAreaName}</td>
                              <td>{row.defectAreaName}</td>
                              <td>
                                <Field name={`result-${row.id}`} component="select" className="form-control">
                                  {
                                    _.map(['UNCHECK', 'TIDY', 'UNTIDY'], (result) => (
                                      <option key={result} value={result}>{result}</option>
                                    ))
                                  }
                                </Field>
                              </td>
                              {results[`result-${row.id}`] && results[`result-${row.id}`] === 'UNTIDY' ?
                                <td>
                                  <button type="button" className="btn btn-link"
                                          onClick={() => setChecklistDailyCurrentField('defectAreaId', row.defectAreaId)}>
                                    Add Defect
                                  </button>
                                </td> : <td/>}
                            </tr>
                          )
                        }) :
                        <tr>
                          <td>No records found.</td>
                        </tr>
                      }
                      </tbody>
                    </table>
                    : undefined
                  }
                </div>
              </div>
            </div>
            <br/>
            <div className="row justify-content-end mg-r-0">
              <button type="submit" className="btn btn-teal mg-r-10" disabled={submitting}>Edit</button>
              <button type="button" className="btn btn-secondary" disabled={submitting} onClick={goBack}>Back</button>
            </div>
            </form>
            {defectAdd}
          </div>  
        </div>  
      </div>
    )
  }
}

export default reduxForm({
  form: 'checklist-daily',
  enableReinitialize: true,
})(ChecklistDaily)


// WEBPACK FOOTER //
// ./src/components/ChecklistDaily.js